/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Deep_Focus_TitleInputs */

const en_subscription_exclusive_feature_deep_focus_title = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Block Distracting Apps`)
};

const ar_subscription_exclusive_feature_deep_focus_title = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حظر التطبيقات المشتتة`)
};

const de_subscription_exclusive_feature_deep_focus_title = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablenkende Apps blockieren`)
};

const es_subscription_exclusive_feature_deep_focus_title = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquea las apps que te distraen`)
};

const fr_subscription_exclusive_feature_deep_focus_title = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquez les applications distrayantes`)
};

const it_subscription_exclusive_feature_deep_focus_title = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocca le app che ti distraggono`)
};

const ja_subscription_exclusive_feature_deep_focus_title = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`気が散るアプリをブロック`)
};

const ko_subscription_exclusive_feature_deep_focus_title = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방해 되는 앱 차단`)
};

const pt_br_subscription_exclusive_feature_deep_focus_title = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueio dos aplicativos que distraem`)
};

const ru_subscription_exclusive_feature_deep_focus_title = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Блокировка отвлекающих приложений`)
};

const th_subscription_exclusive_feature_deep_focus_title = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บล็อกแอปที่รบกวนสมาธิ`)
};

const tr_subscription_exclusive_feature_deep_focus_title = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dikkat Dağıtıcı Uygulamaları Engelle`)
};

const zh_cn_subscription_exclusive_feature_deep_focus_title = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阻挡分心软件`)
};

const zh_tw_subscription_exclusive_feature_deep_focus_title = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阻擋分心 App`)
};

/**
* | output |
* | --- |
* | "Block Distracting Apps" |
*
* @param {Subscription_Exclusive_Feature_Deep_Focus_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_deep_focus_title = /** @type {((inputs?: Subscription_Exclusive_Feature_Deep_Focus_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Deep_Focus_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_deep_focus_title(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_deep_focus_title(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_deep_focus_title(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_deep_focus_title(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_deep_focus_title(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_deep_focus_title(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_deep_focus_title(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_deep_focus_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_deep_focus_title(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_deep_focus_title(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_deep_focus_title(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_deep_focus_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_deep_focus_title(inputs)
	return zh_tw_subscription_exclusive_feature_deep_focus_title(inputs)
});